export const RemoteIconVideo = () => {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_158048_11940)">
                <path
                    d="M4.75 10.3183H2.9375V8.50581C2.9375 8.43706 2.88125 8.38081 2.8125 8.38081H2.0625C1.99375 8.38081 1.9375 8.43706 1.9375 8.50581V10.3183H0.125C0.05625 10.3183 0 10.3746 0 10.4433V11.1933C0 11.2621 0.05625 11.3183 0.125 11.3183H1.9375V13.1308C1.9375 13.1996 1.99375 13.2558 2.0625 13.2558H2.8125C2.88125 13.2558 2.9375 13.1996 2.9375 13.1308V11.3183H4.75C4.81875 11.3183 4.875 11.2621 4.875 11.1933V10.4433C4.875 10.3746 4.81875 10.3183 4.75 10.3183Z"
                    fill="white"
                />
                <path
                    d="M13.25 3.72734L11.25 4.87891V2.50391C11.25 1.95234 10.8016 1.50391 10.25 1.50391H1C0.448438 1.50391 0 1.95234 0 2.50391V8.00391H1.125V2.62891H10.125V11.3789H6V12.5039H10.25C10.8016 12.5039 11.25 12.0555 11.25 11.5039V9.12891L13.25 10.2805C13.5828 10.4727 14 10.232 14 9.84922V4.16016C14 3.77578 13.5828 3.53516 13.25 3.72734ZM12.875 8.76953L11.25 7.83516V6.17422L12.875 5.23828V8.76953Z"
                    fill="white"
                />
                <path
                    d="M3.99929 4.62321C4.06804 4.62321 4.12429 4.56696 4.12429 4.49821V3.74821C4.12429 3.67946 4.06804 3.62321 3.99929 3.62321H2.24929C2.18054 3.62321 2.12429 3.67946 2.12429 3.74821V4.49821C2.12429 4.56696 2.18054 4.62321 2.24929 4.62321H3.99929Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_158048_11940">
                    <rect width="14" height="14" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
